import type { DecorDensity } from "../types";

export interface ShelvingDecorAsset {
  file: string;
  /** Папка в public/models; без неё — первый набор decor-pack. */
  pack?: "decor-pack-2";
  dimensionsMm: readonly [number, number, number];
  baseYaw: number;
  anchor: "bottom" | "top";
  /** Рамки прислоняются к задней стенке ячейки, остальное стоит у передней кромки. */
  placement?: "front" | "back";
  /** Во сколько раз чаще предмет попадает в ячейку: книги — основа стеллажа. */
  weight?: number;
}

export const SHELVING_DECOR_ASSETS = {
  booksRow3: {
    file: "books_row_3.glb",
    dimensionsMm: [220, 290, 70],
    baseYaw: Math.PI / 2,
    anchor: "bottom",
    weight: 3
  },
  booksRow4: {
    file: "books_row_4.glb",
    dimensionsMm: [230, 300, 92],
    baseYaw: Math.PI / 2,
    anchor: "bottom",
    weight: 3
  },
  booksStack2: {
    file: "books_stack_2.glb",
    dimensionsMm: [258, 56, 210],
    baseYaw: 0,
    anchor: "bottom",
    weight: 3
  },
  bowlSpeckled: {
    file: "bowl_speckled.glb",
    dimensionsMm: [240, 86, 240],
    baseYaw: 0,
    anchor: "bottom"
  },
  boxTravertine: {
    file: "box_travertine.glb",
    dimensionsMm: [120, 82, 96],
    baseYaw: 0,
    anchor: "bottom"
  },
  diffuserReed: {
    file: "diffuser_reed.glb",
    dimensionsMm: [124, 337, 67],
    baseYaw: 0,
    anchor: "bottom"
  },
  jarStoneDark: {
    file: "jar_stone_dark.glb",
    dimensionsMm: [110, 80, 110],
    baseYaw: 0,
    anchor: "bottom"
  },
  plantBushSmall: {
    file: "plant_bush_small.glb",
    dimensionsMm: [229, 249, 219],
    baseYaw: 0,
    anchor: "bottom"
  },
  plantPothosTrailing: {
    file: "plant_pothos_trailing.glb",
    dimensionsMm: [246, 471, 266],
    baseYaw: 0,
    anchor: "top"
  },
  sculptureArch: {
    file: "sculpture_arch.glb",
    dimensionsMm: [170, 240, 52],
    baseYaw: 0,
    anchor: "bottom"
  },
  vaseBottleGlazed: {
    file: "vase_bottle_glazed.glb",
    dimensionsMm: [103, 130, 103],
    baseYaw: 0,
    anchor: "bottom"
  },
  vaseGourd: {
    file: "vase_gourd.glb",
    dimensionsMm: [142, 220, 142],
    baseYaw: 0,
    anchor: "bottom"
  },
  vaseRibbed: {
    file: "vase_ribbed.glb",
    dimensionsMm: [111, 161, 111],
    baseYaw: 0,
    anchor: "bottom"
  },
  // Второй набор (27.09): корзина, лампа, рамки, свечи, посуда, растения.
  basketWicker: {
    file: "basket_wicker.glb",
    pack: "decor-pack-2",
    dimensionsMm: [363, 214, 317],
    baseYaw: 0,
    anchor: "bottom"
  },
  boxFabricStorage: {
    file: "box_fabric_storage.glb",
    pack: "decor-pack-2",
    dimensionsMm: [330, 320, 400],
    baseYaw: 0,
    anchor: "bottom"
  },
  candlesTray: {
    file: "candles_tray.glb",
    pack: "decor-pack-2",
    dimensionsMm: [282, 175, 282],
    baseYaw: 0,
    anchor: "bottom"
  },
  clockTable: {
    file: "clock_table.glb",
    pack: "decor-pack-2",
    dimensionsMm: [180, 190, 89],
    baseYaw: 0,
    anchor: "bottom"
  },
  frameLeaningOrganic: {
    file: "frame_leaning_organic.glb",
    pack: "decor-pack-2",
    dimensionsMm: [400, 499, 82],
    baseYaw: 0,
    anchor: "bottom",
    placement: "back"
  },
  frameStandingArches: {
    file: "frame_standing_arches.glb",
    pack: "decor-pack-2",
    dimensionsMm: [160, 208, 91],
    baseYaw: 0,
    anchor: "bottom",
    placement: "back"
  },
  hourglass: {
    file: "hourglass.glb",
    pack: "decor-pack-2",
    dimensionsMm: [100, 200, 100],
    baseYaw: 0,
    anchor: "bottom"
  },
  jugSage: {
    file: "jug_sage.glb",
    pack: "decor-pack-2",
    dimensionsMm: [172, 222, 126],
    baseYaw: 0,
    anchor: "bottom"
  },
  lampTable: {
    file: "lamp_table.glb",
    pack: "decor-pack-2",
    dimensionsMm: [300, 426, 300],
    baseYaw: 0,
    anchor: "bottom"
  },
  mugsPair: {
    file: "mugs_pair.glb",
    pack: "decor-pack-2",
    dimensionsMm: [186, 95, 116],
    baseYaw: 0,
    anchor: "bottom"
  },
  plantCactus: {
    file: "plant_cactus.glb",
    pack: "decor-pack-2",
    dimensionsMm: [120, 308, 120],
    baseYaw: 0,
    anchor: "bottom"
  },
  plantSnake: {
    file: "plant_snake.glb",
    pack: "decor-pack-2",
    dimensionsMm: [219, 648, 304],
    baseYaw: 0,
    anchor: "bottom"
  },
  plantSucculent: {
    file: "plant_succulent.glb",
    pack: "decor-pack-2",
    dimensionsMm: [123, 106, 118],
    baseYaw: 0,
    anchor: "bottom"
  },
  platesStack: {
    file: "plates_stack.glb",
    pack: "decor-pack-2",
    dimensionsMm: [270, 51, 270],
    baseYaw: 0,
    anchor: "bottom"
  },
  vaseGlassEucalyptus: {
    file: "vase_glass_eucalyptus.glb",
    pack: "decor-pack-2",
    dimensionsMm: [338, 579, 292],
    baseYaw: 0,
    anchor: "bottom"
  }
} as const satisfies Record<string, ShelvingDecorAsset>;

export type ShelvingDecorAssetKey = keyof typeof SHELVING_DECOR_ASSETS;

export interface ShelvingDecorZone {
  seed: string;
  widthMm: number;
  heightMm: number;
  depthMm: number;
  /** Centre of the clear zone relative to the module centre. */
  centerXmm: number;
  bottomMm: number;
  topMm: number;
}

export interface ShelvingDecorPlan {
  key: ShelvingDecorAssetKey;
  centerXmm: number;
  anchorYmm: number;
  centerZmm: number;
  dimensionsMm: readonly [number, number, number];
  anchor: "bottom" | "top";
  baseYaw: number;
}

const hashSeed = (seed: string) => {
  let hash = 2166136261;
  for (let index = 0; index < seed.length; index += 1) {
    hash ^= seed.charCodeAt(index);
    hash = Math.imul(hash, 16777619);
  }
  return hash >>> 0;
};

const rotateFromSeed = <T>(values: readonly T[], seed: string) => {
  if (!values.length) return [];
  const start = hashSeed(seed) % values.length;
  return [...values.slice(start), ...values.slice(0, start)];
};

const densityThreshold = (density: DecorDensity | undefined) =>
  density === "minimal" ? 34 : density === "full" ? 88 : 62;

/**
 * Produces a stable, sparse decor arrangement for one clear shelving zone.
 * Every returned asset fits at its authored real-world scale. Nothing is
 * stretched to fill a cell, which keeps books, ceramics and plants believable.
 */
export const planShelvingDecor = (
  zone: ShelvingDecorZone,
  density: DecorDensity | undefined = "normal"
): ShelvingDecorPlan[] => {
  const sideClearance = 18;
  const verticalClearance = 12;
  const frontSetback = 30;
  const backClearance = 14;
  const gap = 24;
  const usableWidth = zone.widthMm - sideClearance * 2;
  const usableHeight = zone.heightMm - verticalClearance * 2;
  const usableDepth = zone.depthMm - frontSetback - 12;
  if (usableWidth < 86 || usableHeight < 72 || usableDepth < 52) return [];

  const occupancy = hashSeed(`${zone.seed}:occupied`) % 100;
  if (occupancy >= densityThreshold(density)) return [];

  const keys = Object.keys(SHELVING_DECOR_ASSETS) as ShelvingDecorAssetKey[];
  const pool = keys.flatMap((key) => {
    const asset: ShelvingDecorAsset = SHELVING_DECOR_ASSETS[key];
    return Array.from({ length: asset.weight ?? 1 }, () => key);
  });
  // Сначала отбираются подходящие по размеру, потом выбор по зерну ячейки:
  // иначе крупные предметы, которые не влезли, отдавали свою очередь соседу
  // по списку, и один и тот же предмет стоял через ячейку.
  const candidates = rotateFromSeed(pool.filter((key) => {
    const asset = SHELVING_DECOR_ASSETS[key];
    const [width, height, depth] = asset.dimensionsMm;
    if (width > usableWidth || height > usableHeight || depth > usableDepth) return false;
    // Свисающее растение крепится под верхнюю полку ячейки и в высокой ячейке
    // будто висит в воздухе (приёмка 11.10, sg-03): на стеллаже его не ставим.
    if (asset.anchor === "top") return false;
    return true;
  }), `${zone.seed}:asset`);
  if (!candidates.length) return [];

  const desiredCount =
    density === "full" && usableWidth >= 540
      ? 2
      : density === "normal" && usableWidth >= 680
        ? 2
        : 1;
  let selected: ShelvingDecorAssetKey[] = [];
  for (const key of candidates) {
    if (selected.length >= desiredCount) break;
    if (selected.includes(key)) continue;
    // Trailing foliage is intentionally a solo composition.
    if (
      (key === "plantPothosTrailing" && selected.length > 0) ||
      selected.includes("plantPothosTrailing")
    ) {
      continue;
    }
    const width = SHELVING_DECOR_ASSETS[key].dimensionsMm[0];
    const usedWidth = selected.reduce(
      (sum, selectedKey) =>
        sum + SHELVING_DECOR_ASSETS[selectedKey].dimensionsMm[0],
      0
    );
    const nextWidth = usedWidth + width + gap * selected.length;
    if (nextWidth <= usableWidth) selected.push(key);
  }
  if (!selected.length) return [];

  const totalWidth =
    selected.reduce(
      (sum, key) => sum + SHELVING_DECOR_ASSETS[key].dimensionsMm[0],
      0
    ) +
    gap * Math.max(0, selected.length - 1);
  const maxJitter = Math.max(0, (usableWidth - totalWidth) * 0.22);
  const signedJitter = ((hashSeed(`${zone.seed}:position`) % 2001) / 1000 - 1) * maxJitter;
  let cursor = zone.centerXmm - totalWidth / 2 + signedJitter;

  return selected.map((key, index) => {
    const asset: ShelvingDecorAsset = SHELVING_DECOR_ASSETS[key];
    const [width, , depth] = asset.dimensionsMm;
    const centerXmm = cursor + width / 2;
    cursor += width + gap;
    const depthJitter = ((hashSeed(`${zone.seed}:depth:${index}`) % 9) - 4) * 1.5;
    return {
      key,
      centerXmm,
      anchorYmm:
        asset.anchor === "top" ? zone.topMm - 7 : zone.bottomMm + 3,
      centerZmm: asset.placement === "back"
        ? -(zone.depthMm - backClearance) + depth / 2
        : -frontSetback - depth / 2 + depthJitter,
      dimensionsMm: asset.dimensionsMm,
      anchor: asset.anchor,
      baseYaw: asset.baseYaw
    };
  });
};
